module.exports = __webpack_public_path__ + "static/media/no-checkout-image.b62947e3.svg";